export default "__VITE_ASSET__5dd19b5d__"